<template>
  <div class="page-wrapper">
    <main class="main">
      <div class="page-header">
        <div class="container">
          <h1 class="page-title mb-0">
            {{ $yuyanbao.lianxiwomen }}
          </h1>
        </div>
      </div>
      <nav class="breadcrumb-nav mb-10 pb-1">
        <div class="container">
          <ul class="breadcrumb">
            <li>
              <router-link to="/">{{ $yuyanbao.shouye }}</router-link>
            </li>
            <li>{{ $yuyanbao.lianxiwomen }}</li>
          </ul>
        </div>
      </nav>
      <div class="page-content contact-us">
        <div class="container">
          <section class="contact-information-section mb-10">
            <div class="swiper-container swiper-theme"
              data-swiper-options="{ 'spaceBetween': 20, 'slidesPerView': 1, 'breakpoints': { '480': { 'slidesPerView': 2}, '768': { 'slidesPerView': 3 }, '992': { 'slidesPerView': 4 } } }">
              <div class="swiper-wrapper row cols-xl-4 cols-md-3 cols-sm-2 cols-1">
                <div class="swiper-slide icon-box text-center icon-box-primary">
                  <span class="icon-box-icon icon-email">
                    <i class="w-icon-envelop-closed"></i>
                  </span>
                  <div class="icon-box-content">
                    <h4 class="icon-box-title">{{ $yuyanbao.youxiang }}</h4>
                    <p>
                      {{ $shezhi.youxiang }}
                    </p>
                  </div>
                </div>
                <div class="swiper-slide icon-box text-center icon-box-primary">
                  <span class="icon-box-icon icon-headphone">
                    <i class="w-icon-headphone"></i>
                  </span>
                  <div class="icon-box-content">
                    <h4 class="icon-box-title">{{ $yuyanbao.dianhua }}</h4>
                    <p>
                      {{ $shezhi.dianhua }}
                    </p>
                  </div>
                </div>
                <div class="swiper-slide icon-box text-center icon-box-primary">
                  <span class="icon-box-icon icon-map-marker">
                    <i class="w-icon-map-marker"></i>
                  </span>
                  <div class="icon-box-content">
                    <h4 class="icon-box-title">{{ $yuyanbao.dizhi }}</h4>
                    <p>
                      {{ $shezhi.dizhi }}
                      {{ $shezhi.codepostal }}
                      {{ $shezhi.chengshi }}
                    </p>
                  </div>
                </div>
                <div class="swiper-slide icon-box text-center icon-box-primary">
                  <span class="icon-box-icon icon-fax">
                    <i class="w-icon-fax"></i>
                  </span>
                  <div class="icon-box-content">
                    <h4 class="icon-box-title">Whatsapp</h4>
                    <p>
                      {{ $shezhi.whatsapp }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <hr class="divider mb-10 pb-1" />
          <section class="contact-section">
            <div class="row gutter-lg pb-3">
              <div class="col-lg-6 mb-8">
                <h4 class="title mb-3">{{ $yuyanbao.changjianwenti }}</h4>
                <div class="accordion accordion-bg accordion-gutter-md accordion-border">
                  <div class="card">
                    <div class="card-header">
                      <a href="'#collapse1" class="collapse">
                        {{ $shezhi.wenti1 }}
                      </a>
                    </div>
                    <div id="collapse1" class="card-body expanded">
                      <p class="mb-0">
                        {{ $shezhi.wenti1huida }}
                      </p>
                    </div>
                  </div>
                  <div class="card">
                    <div class="card-header">
                      <a href="#collapse2" class="expand">
                        {{ $shezhi.wenti2 }}
                      </a>
                    </div>
                    <div id="collapse2" class="card-body collapsed">
                      <p class="mb-0">
                        {{ $shezhi.wenti2huida }}
                      </p>
                    </div>
                  </div>
                  <div class="card">
                    <div class="card-header">
                      <a href="#collapse3" class="expand">
                        {{ $shezhi.wenti3 }}
                      </a>
                    </div>
                    <div id="collapse3" class="card-body collapsed">
                      <p class="mb-0">
                        {{ $shezhi.wenti3huida }}
                      </p>
                    </div>
                  </div>
                  <div class="card">
                    <div class="card-header">
                      <a href="#collapse4" class="expand">
                        {{ $shezhi.wenti4 }}
                      </a>
                    </div>
                    <div id="collapse4" class="card-body collapsed">
                      <p class="mb-0">
                        {{ $shezhi.wenti4huida }}
                      </p>
                    </div>
                  </div>
                  <div class="card">
                    <div class="card-header">
                      <a href="#collapse5" class="expand">
                        {{ $shezhi.wenti5 }}
                      </a>
                    </div>
                    <div id="collapse5" class="card-body collapsed">
                      <p class="mb-0">
                        {{ $shezhi.wenti5huida }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-6 mb-8">
                <h4 class="title mb-3">{{ $yuyanbao.xinxi }}</h4>
                <div class="form contact-us-form">
                  <div class="form-group">
                    <label for="username">{{ $yuyanbao.xing }}</label>
                    <input type="text" id="username" name="username" class="form-control" v-model="nom" />
                  </div>
                  <div class="form-group">
                    <label for="email_1">{{ $yuyanbao.youxiang }}</label>
                    <input type="email" id="email_1" name="email_1" class="form-control" v-model="email" />
                  </div>
                  <div class="form-group">
                    <label for="message">{{ $yuyanbao.xiangqing }}</label>
                    <textarea id="message" name="message" cols="30" rows="5" class="form-control"
                      v-model="message"></textarea>
                  </div>
                  <button class="btn btn-dark btn-rounded" @click="post_message_http" :disable="sentloading">
                    <div class="btn-text">
                      <i class="w-icon-store-seo mr-1 xuanzhuan" v-if="sentloading"></i>
                      {{ $yuyanbao.fasong }}
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </section>
        </div>
        <iframe :src="$shezhi.googlemaps" width="100%" height="350" style="border: 0" allowfullscreen="" loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"></iframe>
      </div>
    </main>
  </div>
</template>

<script>
import { postMessage } from "@/api/message";

export default {
  name: "ComtactUs",
  components: {},
  data () {
    return {
      nom: "",
      email: "",
      message: "",
      sentloading: false,
    };
  },

  methods: {
    post_message_http () {
      if (this.sentloading) return;
      if (this.nom === "") {
        this.toast({
          icon: "info",
          title: this.$yuyanbao.xing,
        });
        return;
      }
      if (this.email === "" || !/^[\.a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(this.email)) {
        this.toast({
          icon: "info",
          title: this.$yuyanbao.youxiang,
        });
        return;
      }
      if (this.message === "") {
        this.toast({
          icon: "info",
          title: this.$yuyanbao.xinxi,
        });
        return;
      }
      this.sentloading = true;
      setTimeout(() => {
        postMessage({
          xingming: this.nom,
          email: this.email,
          message: this.message,
        })
          .then((data) => {
            this.toast_http({ status: data.status })
            if (data.status === "SUCCESSED") {
              this.xingming = "";
              this.email = "";
              this.message = "";
            }
          })
          .finally(() => (this.sentloading = false));
      }, 500);
    },
  },
};
</script>

<style scoped>
.btn-text {
  position: relative;
  display: inline-block;
  width: auto;
  padding: 0 25px;
}

.xuanzhuan {
  position: absolute;
  top: 6px;
  left: 5px;
  animation: anixuanzhuan 0.8s infinite linear;
}

@keyframes anixuanzhuan {
  0% {
    transform: rotate(0deg);
  }

  25% {
    transform: rotate(90deg);
  }

  50% {
    transform: rotate(180deg);
  }

  75% {
    transform: rotate(270deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
